export default "__VITE_ASSET__BcFEaP53__"